import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { IAdminDevicesState } from "./state";

export const defaultState: IAdminDevicesState = {
    devices: [],
};

export const adminDevicesModule = {
    state: defaultState,
    mutations,
    actions,
    getters
};